import {FC, ReactNode} from "react"
import cn from "classnames"
import styles from "./footer.module.css"

interface FooterProps {
  children: ReactNode
  className?: string
  noBg?: boolean
}

export const Footer: FC<FooterProps> = ({children, className, noBg = false}) => (
  <footer
    className={cn(
      "h-40 tablet:h-52 flex flex-col items-center justify-center",
      className,
      noBg ? styles.noBg : null
    )}
  >
    {children}
  </footer>
)
